import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './admin.component';
import { ModuleComponent } from './module/module.component';
import { UserComponent } from './user/user.component';
import { UserDialogComponent } from './user/show/user-dialog.component';
import { ShowModuleComponent } from './module/show/show-module.component';
import { GroupUserComponent } from './group-user/group-user.component';
import { ShowGroupUserComponent } from './group-user/show/show-group-user.component';
import { ResultImportComponent } from './result-import/result-import.component';
import { ColumnRenderStatusComponent } from './result-import/column-render-status.component';
import { ShowDepartamentComponent } from './departament/show/show-departament.component';
import { DepartamentComponent } from './departament/departament.component';
import { TypeTemplateComponent } from './type-template/type-template.component';
import { ShowTypeTemplateComponent } from './type-template/show/show-type-template.component';
import { TemplateComponent } from './template/template.component';
import { ShowTemplateComponent } from './template/show/show-template.component';
import { OrganizationUnitComponent } from './organization-unit/organization-unit.component';
import { ShowOrganizationUnitComponent } from './organization-unit/show/show-organization-unit.component';
import { UserActivationComponent } from './user/user-activation/user-activation.component';
import { InternalSearchComponent } from './internal-search/internal-search.component';
import { ShowInternalSearchComponent } from './internal-search/show/show-internal-search.component';
import { MyCustomComponent } from './internal-search/custom-action.component';
import { DashboardInternalSearchComponent } from './internal-search/dashboard/dashboard-internal-search.component';
import { DashboardDetailComponent } from './internal-search/dashboard/detail/dashboard-detail.component';
import { MyCustomDetailDashComponent } from './internal-search/custom-action-detail-dash.component';
import { HelpCenterCategoryComponent } from './help-center-category/help-center-category.component';
import { ShowHelpCenterCategoryComponent } from './help-center-category/show/show-help-center-category.component';
import { HelpCenterArticleComponent } from './help-center-article/help-center-article.component';
import { ShowHelpCenterArticleComponent } from './help-center-article/show/show-help-center-article.component';
import { MyAccountComponent } from './my-account/my-account.component';
import { HelpCenterSearchHistoryComponent } from './help-center-search-history/help-center-search-history.component';
import { GuidelineComponent } from './guideline/guideline.component';
import { ShowGuidelineComponent } from './guideline/show/show-guideline.component';
import { PeriodComponent } from './period/period.component';
import { ShowPeriodComponent } from './period/show/show-period.component';
import { EhsMicroIndicadorComponent } from './employee-health-score/ehs-micro-indicador.component';
import { ShowEHSMicroIndicadorComponent } from './employee-health-score/show/show-ehs-micro-indicador.component';
import { ImportExternalComponent } from './employee-health-score/import-external/import-external.component';
import { CustomMenuComponent } from './internal-search/custom-action-menu.component';
import { MyCustomImportEHSComponent } from './employee-health-score/custom-action-ehs-import';
import { ColumnStatusPeriodComponent } from './period/column-status-period.component';
import { ColumnBooleanPeriodComponent } from './period/column-boolean.component';
import { TypeHiringUserComponent } from './type-hiring-user/type-hiring-user.component';
import { ShowTypeHiringUserComponent } from './type-hiring-user/show/show-type-hiring-user.component';
import { modalityWorkUserComponent } from './modality-work-user/modality-work-user.component';
import { ShowModalityWorkuserComponent } from './modality-work-user/show/show-modality-work-user.component';


const routes: Routes = [{
  path: '',
  component: AdminComponent,
  children: [
    {
      path: 'module',
      component: ModuleComponent,
    },
    {
      path: 'my-account',
      component: MyAccountComponent,
    },
    {
      path: 'module/:parentId',
      component: ShowModuleComponent,
    },
    {
      path: 'help-center-category',
      component: HelpCenterCategoryComponent,
    },
    {
      path: 'help-center-category/:parentId',
      component: ShowHelpCenterCategoryComponent,
    },
    {
      path: 'help-center-article',
      component: HelpCenterArticleComponent,
    },
    {
      path: 'help-center-article/:parentId',
      component: ShowHelpCenterArticleComponent,
    },
    {
      path: 'help-center-search-history',
      component: HelpCenterSearchHistoryComponent,
    },
    {
      path: 'groupUser',
      component: GroupUserComponent,
    },
    {
      path: 'groupUser/:parentId',
      component: ShowGroupUserComponent,
    },
    {
      path: 'user',
      component: UserComponent,
    },
    {
      path: 'user/activation/show',
      component: UserActivationComponent,
    },
    {
      path: 'user/:parentId',
      component: UserDialogComponent,
    },
    {
      path: 'departament',
      component: DepartamentComponent,
    },
    {
      path: 'departament/:parentId',
      component: ShowDepartamentComponent,
    },
    {
      path: 'organization-unit',
      component: OrganizationUnitComponent,
    },
    {
      path: 'organization-unit/:parentId',
      component: ShowOrganizationUnitComponent,
    },
    {
      path: 'type-template',
      component: TypeTemplateComponent,
    },
    {
      path: 'type-template/:parentId',
      component: ShowTypeTemplateComponent,
    },
    {
      path: 'type-hiring-user',
      component: TypeHiringUserComponent,
    },
    {
      path: 'type-hiring-user/:parentId',
      component: ShowTypeHiringUserComponent,
    },
    {
      path: 'modality-work-user',
      component: modalityWorkUserComponent,
    },
    {
      path: 'modality-work-user/:parentId',
      component: ShowModalityWorkuserComponent,
    },
    {
      path: 'internal-search',
      component: InternalSearchComponent,
    },
    {
      path: 'internal-search/:parentId',
      component: ShowInternalSearchComponent,
    },
    // {
    //   path: 'internal-search/dashboard/:parentId',
    //   component: DashboardInternalSearchComponent,
    // },
    {
      path: 'internal-search/dashboard/detail/:internalSearchId/:userId',
      component: DashboardDetailComponent,
    },
    {
      path: 'template',
      component: TemplateComponent,
    },
    {
      path: 'template/:parentId',
      component: ShowTemplateComponent,
    },
    {
      path: 'result-import',
      component: ResultImportComponent,
    },
    {
      path: 'guideline',
      component: GuidelineComponent,
    },
    {
      path: 'guideline/:parentId',
      component: ShowGuidelineComponent,
    },
    {
      path: 'period',
      component: PeriodComponent,
    },
    {
      path: 'period/:parentId',
      component: ShowPeriodComponent,
    },
    {
      path: 'ehs-micro-indicador',
      component: EhsMicroIndicadorComponent,
    },
    {
      path: 'ehs-micro-indicador/:parentId',
      component: ShowEHSMicroIndicadorComponent,
    },
    {
      path: 'ehs-micro-indicador/import/:parentId',
      component: ImportExternalComponent,
    },
  ],
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRoutingModule {
}

export const routedComponents = [
  AdminComponent,
  ModuleComponent,
  UserComponent,
  InternalSearchComponent,
  ShowInternalSearchComponent,
  // DashboardInternalSearchComponent,
  UserDialogComponent,
  UserActivationComponent,
  DepartamentComponent,
  ShowDepartamentComponent,
  OrganizationUnitComponent,
  ShowOrganizationUnitComponent,
  TypeTemplateComponent,
  ShowTypeTemplateComponent,
  TemplateComponent,
  ShowTemplateComponent,
  TypeHiringUserComponent,
  ShowTypeHiringUserComponent,
  modalityWorkUserComponent,
  ShowModalityWorkuserComponent,
  ShowModuleComponent,
  GroupUserComponent,
  ShowGroupUserComponent,
  ResultImportComponent,
  ColumnRenderStatusComponent,
  MyCustomComponent,
  //MyCustomDetailDashComponent,
  DashboardDetailComponent,
  HelpCenterCategoryComponent,
  ShowHelpCenterCategoryComponent,
  HelpCenterArticleComponent,
  ShowHelpCenterArticleComponent,
  MyAccountComponent,
  HelpCenterSearchHistoryComponent,
  GuidelineComponent,
  ShowGuidelineComponent,
  PeriodComponent,
  ShowPeriodComponent,
  EhsMicroIndicadorComponent,
  ShowEHSMicroIndicadorComponent,
  ImportExternalComponent,
  CustomMenuComponent,
  MyCustomImportEHSComponent,
  ColumnStatusPeriodComponent,
  ColumnBooleanPeriodComponent
];
